export const closestNumber = (numbers, number, roundUp = false) => {
  number = roundUp ? Math.round(number) + 1 : number;
  return numbers.reduce((a, b) => {
    return Math.abs(b - number) < Math.abs(a - number)
      ? Math.abs(b)
      : Math.abs(a);
  });
};
